var React = require('react');

function StreamlineLine18NewDocumentLayer (props) {
    return React.createElement("svg",props,[React.createElement("g",{"fill":"none","stroke":"#000","strokeLinejoin":"round","strokeMiterlimit":"10","key":0},[React.createElement("path",{"d":"M14.5 12.5v7h-12V.5h19v12zM21.5 12.5l-7 7","key":0}),React.createElement("path",{"strokeLinecap":"round","d":"M3.5 21.5h17V17M4.5 23.5h15","key":1})]),React.createElement("g",{"key":1},React.createElement("path",{"fill":"none","d":"M0 0h24v24H0z"}))]);
}

StreamlineLine18NewDocumentLayer.displayName = "StreamlineLine18NewDocumentLayer";

StreamlineLine18NewDocumentLayer.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = StreamlineLine18NewDocumentLayer;

StreamlineLine18NewDocumentLayer.default = StreamlineLine18NewDocumentLayer;



//////////////////
// WEBPACK FOOTER
// ./src/shared/static/icons/streamline-line-18-new-document-layer.svg
// module id = 770
// module chunks = 0